import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

export function LinkedInRef({ margin = 'auto' }) {
    const data = useStaticQuery(graphql`
        query {
            s1: file(relativePath: { eq: "LI-In-Bug.png" }) {
                childImageSharp {
                    fluid(maxWidth: 30) {
                        ...GatsbyImageSharpFluid_tracedSVG
                    }
                }
            }
        }
    `)
    return (
        <div style={{ width: 30, height: 25, margin }}>
            <a href="https://www.linkedin.com/company/ll33a-dk" target="_blank">
                <Img
                    title="LinkedIn"
                    alt="LinkedIn logo"
                    className="logo-ref"
                    imgStyle={{ objectFit: 'contain' }}
                    fluid={data.s1.childImageSharp.fluid}
                />
            </a>
        </div>
    )
}
